export default "__VITE_ASSET__e03fd880__"